import { ZEGO_APP_ID, ZEGOCLOUD_ROOM_URL } from "../constants/config";
import { ZegoExpressEngine } from "zego-express-engine-webrtc";

export const zegoInit = () => {
  return new ZegoExpressEngine(
    Number(ZEGO_APP_ID),
    ZEGOCLOUD_ROOM_URL
  );
};
